$bog_ui_app $mol_book2
	plugins /
		^
		<= Theme $mol_theme_auto
		<= Tip $bog_ui_tooltip
	event *
		^
		keydown? <=> global_keydown? null
	command_showed? false
	Command $bog_ui_command
		showed? <=> command_showed?
	Badge_page $bog_ui_app_badge
	Empty_page $bog_ui_app_empty
	Skeleton_page $bog_ui_app_skeleton
	Breadcrumb_page $bog_ui_app_breadcrumb
	Sidebar_page $bog_ui_app_sidebar
	Sheet_page $bog_ui_app_sheet
	Toast_page $bog_ui_app_toast
	Command_page $bog_ui_app_command
	Table_page $bog_ui_app_table
	Overview_page $bog_ui_app_overview
	Divider_page $bog_ui_app_divider
	Tooltip_page $bog_ui_app_tooltip
	pages /
		<= Nav $bog_ui_sidebar
			mode? <=> sidebar_mode? \dock
			items /
				<= Overview_nav $bog_ui_sidebar_item
					Icon <= Overview_icon $mol_icon_view_grid
					label \Overview
					active <= overview_active false
					click? <=> nav_overview? null
				<= Badge_nav $bog_ui_sidebar_item
					Icon <= Badge_icon $mol_icon_tag
					label \Badge
					active <= badge_active false
					click? <=> nav_badge? null
				<= Empty_nav $bog_ui_sidebar_item
					Icon <= Empty_icon $mol_icon_file
					label \Empty State
					active <= empty_active false
					click? <=> nav_empty? null
				<= Skeleton_nav $bog_ui_sidebar_item
					Icon <= Skeleton_icon $mol_icon_rectangle
					label \Skeleton
					active <= skeleton_active false
					click? <=> nav_skeleton? null
				<= Breadcrumb_nav $bog_ui_sidebar_item
					Icon <= Breadcrumb_icon $mol_icon_navigation
					label \Breadcrumb
					active <= breadcrumb_active false
					click? <=> nav_breadcrumb? null
				<= Sidebar_nav $bog_ui_sidebar_item
					Icon <= Sidebar_icon $mol_icon_dock_left
					label \Sidebar
					active <= sidebar_active false
					click? <=> nav_sidebar? null
				<= Sheet_nav $bog_ui_sidebar_item
					Icon <= Sheet_icon $mol_icon_card
					label \Sheet
					active <= sheet_active false
					click? <=> nav_sheet? null
				<= Toast_nav $bog_ui_sidebar_item
					Icon <= Toast_icon $mol_icon_bell
					label \Toast
					active <= toast_active false
					click? <=> nav_toast? null
				<= Command_nav $bog_ui_sidebar_item
					Icon <= Command_icon $mol_icon_console
					label \Command
					active <= command_active false
					click? <=> nav_command? null
				<= Table_nav $bog_ui_sidebar_item
					Icon <= Table_icon $mol_icon_table
					label \Data Table
					active <= table_active false
					click? <=> nav_table? null
				<= Divider_nav $bog_ui_sidebar_item
					Icon <= Divider_icon $mol_icon_minus
					label \Divider
					active <= divider_active false
					click? <=> nav_divider? null
				<= Tooltip_nav $bog_ui_sidebar_item
					Icon <= Tooltip_icon $mol_icon_message
					label \Tooltip
					active <= tooltip_active false
					click? <=> nav_tooltip? null
		<= Content_page $mol_page
			title <= page_title \Components
			tools /
				<= Theme_toggle $mol_lights_toggle
			body /
				<= Page_body $mol_view
					sub /
						<= page_text \Select a component from the sidebar
